import React, { useState } from 'react';
import styled from 'styled-components';
import { observer } from "mobx-react-lite";
import { useTranslation } from 'react-i18next';
import { clientCollectTranslatableEntityData } from '../../helper/translationHelpers';
import { validLanguages } from '../../../shared/data/languages';
import { LanguageDropdown } from './LanguageDropdown';
import { wrapIterator } from '../../../shared/helper/IterableIteratorWrapper';
import { isBlank } from '../../../shared/helper/generalHelpers';
import { TranslationHeader } from './TranslationHeader';
const Table = styled.table.withConfig({
  displayName: "TranslationStats__Table",
  componentId: "sc-1js5hci-0"
})(["border-collapse:collapse;tr{border:1px solid lightgrey;}th,td{padding:5px 10px;}"]);
const TdLeft = styled.td.withConfig({
  displayName: "TranslationStats__TdLeft",
  componentId: "sc-1js5hci-1"
})(["text-align:right;"]);
const TdCenter = styled.td.withConfig({
  displayName: "TranslationStats__TdCenter",
  componentId: "sc-1js5hci-2"
})(["text-align:center;"]);

function getTranslatedNeutralStringPercentage(translatedStrings, language) {
  let translatedCount = 0;

  for (const translatedString of translatedStrings) {
    if (!isBlank(translatedString.get(language, false))) {
      translatedCount++;
    }
  }

  return translatedCount / translatedStrings.length;
}

export const TranslationStats = observer(() => {
  const {
    t
  } = useTranslation();
  const [sourceLanguage, setSourceLanguage] = useState("de");
  const translatableEntities = clientCollectTranslatableEntityData(sourceLanguage);
  const translatedStrings = new Array();
  const translatedStringsByEntityLabel = new Map();

  for (const {
    label,
    translateableStrings
  } of translatableEntities) {
    if (!translatedStringsByEntityLabel.has(label)) {
      translatedStringsByEntityLabel.set(label, []);
    }

    const entityTranslatedStrings = translateableStrings.map(translatableString => translatableString.translatedString);
    translatedStrings.push(...entityTranslatedStrings);
    translatedStringsByEntityLabel.get(label).push(...entityTranslatedStrings);
  }

  const languagesExceptSource = validLanguages.filter(language => language != sourceLanguage);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TranslationHeader, {
    titleKey:
    /*t*/
    "translation.stats"
  }), /*#__PURE__*/React.createElement("div", null, t("translation.base_language"), ": ", /*#__PURE__*/React.createElement(LanguageDropdown, {
    value: sourceLanguage,
    setValue: setSourceLanguage
  })), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", null, t("translation.stats_description")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TdLeft, null), /*#__PURE__*/React.createElement(TdCenter, null, t("translation.full_text_count")), languagesExceptSource.map(language => /*#__PURE__*/React.createElement(TdCenter, {
    key: language
  }, t("translation.language_" + language)))), wrapIterator(translatedStringsByEntityLabel.keys()).map(entityLabel => /*#__PURE__*/React.createElement("tr", {
    key: entityLabel
  }, /*#__PURE__*/React.createElement(TdLeft, null, entityLabel), /*#__PURE__*/React.createElement(TdCenter, null, translatedStringsByEntityLabel.get(entityLabel).length), languagesExceptSource.map(language => /*#__PURE__*/React.createElement(TdCenter, {
    key: language
  }, Math.floor(getTranslatedNeutralStringPercentage(translatedStringsByEntityLabel.get(entityLabel), language) * 100), "%")))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement(TdLeft, null, "Total"), /*#__PURE__*/React.createElement(TdCenter, null, translatedStrings.length), languagesExceptSource.map(language => /*#__PURE__*/React.createElement(TdCenter, {
    key: language
  }, Math.floor(getTranslatedNeutralStringPercentage(translatedStrings, language) * 100), "%"))))));
});